<h4 mat-dialog-title data-testid="create-company-title">Редактирование компании</h4>
<app-close-button [formGroup]="companyForm" [dialogRef]="dialogRef"/>
<mat-dialog-content>
    <app-loader [isLoading]="loading()"/>
    <form class="flex-column" [formGroup]="companyForm" (ngSubmit)="onSubmit()">
        <mat-form-field appearance="fill">
            <mat-label>Название</mat-label>
            <input matInput formControlName="name" data-testid="company-name-input"/>
        </mat-form-field>

        <mat-checkbox formControlName="paymentDevice" matTooltip="Для добовления в компаниию кассовго аппарата">
            Интеграция с кассовым оборудованием
        </mat-checkbox>

        <mat-checkbox formControlName="canExecutorChangePrice" matTooltip="Позволить исполнителю задавать цену работ в конкретной заявке">
            Исполнитель может менять стоимость работ в заявке
        </mat-checkbox>

        <mat-checkbox formControlName="canExecutorAddEquipment" matTooltip="Позволить исполнителю добавлять своё оборудование прямо в заявке">
            Исполнитель может добавлять своё оборудование в заявке
        </mat-checkbox>

        <mat-form-field appearance="fill" class="field-item">
            <mat-label>Часовой пояс</mat-label>
            <input  type="text" matInput formControlName="timeZone"  [matAutocomplete]="auto" />
            <mat-autocomplete #auto="matAutocomplete">
                @for (zone of filteredTimezones | async; track zone) {
                    <mat-option [value]="zone">{{ zone }}</mat-option>
                }
            </mat-autocomplete>
        </mat-form-field>

        @if (companyForm.controls['paymentDevice'].value) {
            <mat-form-field appearance="fill" class="field-item">
                <mat-label>Провайдер кассы</mat-label>
                <mat-select formControlName="cashProvider">
                    @for (provider of cashProviders; track provider) {
                        <mat-option [value]="provider">{{ provider }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="fill" class="field-item">
                <mat-label>JSON настройки/креды провайдера</mat-label>
                <textarea matInput rows="6" formControlName="cashProviderConfigJson" placeholder='{"apiUrl":"https://...","clientKey":"..."}'></textarea>
            </mat-form-field>
        }


        <div class="flex justify-between">
            <button mat-stroked-button class="w-40" color="accent" type="button" [disabled]="!company.data.id" (click)="deleteCompany(company.data.id)">Удалить</button>
            <button mat-flat-button class="w-40" color="primary" type="submit" [disabled]="!companyForm.valid" data-testid="save-company-button">Сохранить</button>
        </div>
    </form>

</mat-dialog-content>
